
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as news16gc_t1_ci3hMZqDtq5RIoNmU04ftYKaG7RBwGAt1fwMeta } from "/opt/render/project/src/pages/news.vue?macro=true";
import { default as indexOC_Okt6Gb3_dVbF2GXnGH_OSvVXRLhw23L3x7pjqOAIMeta } from "/opt/render/project/src/pages/index.vue?macro=true";
import { default as about_45us_45UYtXg77l94TQ9FvfmSYyM_458e3Ep70BildXKMHT6owgMeta } from "/opt/render/project/src/pages/about-us.vue?macro=true";
import { default as feedbacksCZezJai42bV_45nHDSmpbJ14TRZ9FvswgUq_DTYsnPQi4Meta } from "/opt/render/project/src/pages/feedbacks.vue?macro=true";
import { default as coming_45soon_pRURu8XgQ_45W4QoKLTiQXcTB3YOnn3giJ_D0NlyPV8IMeta } from "/opt/render/project/src/pages/coming-soon.vue?macro=true";
import { default as interactionht3Qc8uerkgkXCPRqw8s349DyIhUhxWxvZtVI4JBZAQMeta } from "/opt/render/project/src/pages/interaction.vue?macro=true";
import { default as eligibility_45policyyeJ9I_45FY2gPUQNooHIaxDURID7VDMpo_SEkUddME9dkMeta } from "/opt/render/project/src/pages/eligibility-policy.vue?macro=true";
import { default as rent_45gallerypPNxUINEc4Gfh2Z6AnydLQj2IaGqHPpUIQAWOrjRoK4Meta } from "/opt/render/project/src/pages/houses/rent-gallery.vue?macro=true";
import { default as rent_45criterialbcrsrTZQczrwTPlhY4sO6EkVbF0hrDRZGydamSBfs0Meta } from "/opt/render/project/src/pages/houses/rent-criteria.vue?macro=true";
import { default as non_45technical_45summaryxiBUjSJ0k8e_45FmcTLPbc3K8iEn_458npv4IRvHWYCTShwMeta } from "/opt/render/project/src/pages/non-technical-summary.vue?macro=true";
import { default as indexHH8MsqFe0Cfq2Q2tC3uwUZdPgydj4kdkQljR7Gz0g3wMeta } from "/opt/render/project/src/pages/houses/[houseId]/index.vue?macro=true";
import { default as purchase_45galleryP3GBFhp0OGS3zJgkKX63B4OrtYep1RiPApqO56WueWIMeta } from "/opt/render/project/src/pages/houses/purchase-gallery.vue?macro=true";
import { default as purchase_45criteriayzbI8J2IO7Qs8maVAxRvJlcS1MQN2tkAL7w61rYBTloMeta } from "/opt/render/project/src/pages/houses/purchase-criteria.vue?macro=true";
import { default as rent_45request_45statusesAmjyRkyamH873QTXR5cC2AUxIyjIo9trK7NHQDtkYDkMeta } from "/opt/render/project/src/pages/houses/rent-request-statuses.vue?macro=true";
export default [
  {
    name: "news",
    path: "/news",
    component: () => import("/opt/render/project/src/pages/news.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/opt/render/project/src/pages/index.vue")
  },
  {
    name: "about-us",
    path: "/about-us",
    component: () => import("/opt/render/project/src/pages/about-us.vue")
  },
  {
    name: "feedbacks",
    path: "/feedbacks",
    component: () => import("/opt/render/project/src/pages/feedbacks.vue")
  },
  {
    name: "coming-soon",
    path: "/coming-soon",
    component: () => import("/opt/render/project/src/pages/coming-soon.vue")
  },
  {
    name: "interaction",
    path: "/interaction",
    component: () => import("/opt/render/project/src/pages/interaction.vue")
  },
  {
    name: "eligibility-policy",
    path: "/eligibility-policy",
    component: () => import("/opt/render/project/src/pages/eligibility-policy.vue")
  },
  {
    name: "houses-rent-gallery",
    path: "/houses/rent-gallery",
    component: () => import("/opt/render/project/src/pages/houses/rent-gallery.vue")
  },
  {
    name: "houses-rent-criteria",
    path: "/houses/rent-criteria",
    component: () => import("/opt/render/project/src/pages/houses/rent-criteria.vue")
  },
  {
    name: "non-technical-summary",
    path: "/non-technical-summary",
    component: () => import("/opt/render/project/src/pages/non-technical-summary.vue")
  },
  {
    name: "houses-houseId",
    path: "/houses/:houseId()",
    component: () => import("/opt/render/project/src/pages/houses/[houseId]/index.vue")
  },
  {
    name: "houses-purchase-gallery",
    path: "/houses/purchase-gallery",
    component: () => import("/opt/render/project/src/pages/houses/purchase-gallery.vue")
  },
  {
    name: "houses-purchase-criteria",
    path: "/houses/purchase-criteria",
    component: () => import("/opt/render/project/src/pages/houses/purchase-criteria.vue")
  },
  {
    name: "houses-rent-request-statuses",
    path: "/houses/rent-request-statuses",
    component: () => import("/opt/render/project/src/pages/houses/rent-request-statuses.vue")
  }
]